import React from 'react';
import { Spinner } from '@chakra-ui/react';

const Loader = ({size = 'md'}) => <Spinner size={size} color='teal'/>;

export default Loader;